import { ReactNode } from 'react';

const toLowerCaseLabel = (label: string | ReactNode): string | ReactNode => {
  return typeof label === 'string' ? label.toLowerCase() : label;
};

export default toLowerCaseLabel;
